import React, {useState} from 'react';
import styles from "./styles";
import Link from "@mui/material/Link";
import WebsaUITheme from '../Shared/WebsaUITheme';
import ThemeProvider from '../Shared/ThemeProvider';

import RailsForm from '../Shared/RailsForm';
import RailsRoutes from '../Shared/RailsRoutes';

import OutlinedInput from "../Shared/OutlinedInput"
import Button from "@mui/material/Button"
import CheckboxLabel from "../Shared/CheckboxLabel/CheckboxLabel";
import Copyright from "../Shared/Copyright/Copyright";

import { tss } from 'tss-react';
import WebsaSelect from "../Shared/WebsaSelect";
import _ from "lodash";


import LogoHeader from "../Shared/LogoHeader/LogoHeader";
import Slider from "../Shared/Slider/Slider";

export default function ContactsForm(props) {
  const theme = ThemeProvider(props.theme);
  const { classes, cx } = tss.create(styles(theme))();
  const [contacts, setContacts] = useState(props.user.contacts);
  const [errors, setErrors] = useState([]);
  const error = props.flash.alert;

  const capitalize = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const channelOptions  = props.channel_options.map(item => ({ value: item, label: capitalize(item) }));
  const labelOptions = props.label_options.map(item => ({ value: item, label: capitalize(item) }));

  const formAttrs = {
    action: RailsRoutes.contacts_user_path(),
    method: 'patch'
  }

  const addContact = () => () => {
    const newContact = { channel: "email", value: "", label: "general" };
    setContacts([...contacts, newContact]);
  }

  const updateContactChannel = (index) => (channel) => {
    const updatedContacts = [...contacts];
    updatedContacts[index] = {
      ...updatedContacts[index],
      channel: channel,
      error: null
    };

    setContacts(updatedContacts);
  }

  const updateContactLabel = (index) => (label) => {
    const updatedContacts = [...contacts];
    updatedContacts[index] = {
      ...updatedContacts[index],
      label: label,
      error: null
    };
    setContacts(updatedContacts);
  }

  const updateContactValue = (index) => (value) => {
    const updatedContacts = [...contacts];
    updatedContacts[index] = {
      ...updatedContacts[index],
      value: value,
      error: null
    };
    setContacts(updatedContacts);
  }

  const removeContact = (index) => () => {
    const updatedContacts = [...contacts];

    if (updatedContacts[index].id) {
      updatedContacts[index].destroy = "1";
    } else {
      updatedContacts.splice(index, 1);
    }

    if (updatedContacts.filter((contact) => contact.destroy !== "1").length === 0) {
      updatedContacts.push({ channel: "email", value: "", label: "general" });
    }
    setContacts(updatedContacts);
  }

  return (
    <WebsaUITheme theme={props.theme}>
      <div className={classes.root}>
        <LogoHeader/>
        <div className={classes.slider}>
          <Slider/>
        </div>
        <div className={classes.form}>
          <div className={classes.head}>
            <p>
              Sign in as a different user? <Link rel="stylesheet" data-method="DELETE" href={RailsRoutes.destroy_user_session_path()}>Sign out</Link>
            </p>
          </div>
          <RailsForm attrs={formAttrs}>
            <div>
              <div className={classes.root}>
                <div className={classes.contactForm}>
                  <h3 className={classes.formTitle}>Contacts verification</h3>

                  <div className={cx(classes.banner, classes.contactBanner)}>
                    <div className={classes.bannerInner}>
                      <span className="ico-closed" />

                      <span className={classes.bannerSeparator}/>

                      <div className={classes.bannerColumn}>
                        <div className={classes.bannerTitle}>
                          Dear Client,
                          <br/>
                          You haven't updated your contact information for a long time. According to our policy, we require you to verify your contact information at least once every 180 days.
                        </div>

                        <div className={classes.bannerMessage}>
                          Please update your contact information below to continue using our services without any interruptions.
                        </div>
                      </div>
                    </div>
                  </div>

                  {
                    contacts.map((contact, index) => {
                      return (
                        <div>
                        <div className={contact.destroy === "1" ? classes.stepHidden : classes.contactContainer} key={index}>
                          <input type="hidden" name={`user[contacts_attributes][][id]`} value={contact.id}/>
                          <input type="hidden" name={`user[contacts_attributes][][_destroy]`} value={contact.destroy}/>

                          <WebsaSelect
                            name={`user[contacts_attributes][][channel]`}
                            width={125}
                            options={channelOptions}
                            isSearchable
                            value={_.find(channelOptions, {value: contact.channel})}
                            onChange={updateContactChannel(index)}
                          />
                          <OutlinedInput
                            customClass={classes.textField}
                            name={`user[contacts_attributes][][value]`}
                            placeholder="Value"
                            isUncontroled
                            noAdditionalBtn
                            value={contact.value}
                            onChange={updateContactValue(index)}
                          />
                          <WebsaSelect
                            name={`user[contacts_attributes][][label]`}
                            width={130}
                            options={labelOptions}
                            placeholder="Label"
                            isSearchable
                            value={_.find(labelOptions, {value: contact.label})}
                            onChange={updateContactLabel(index)}
                          />
                          <Button className={classes.removeContactButton} variant="text" color="primary" onClick={removeContact(index)}>
                            <span className="ico-delete"/>
                          </Button>
                        </div>
                        { contact.error &&
                          <span className={classes.contactErrorBlock}>{capitalize(contact.error)}</span>
                        }
                        </div>
                      )
                    })
                  }
                  <Button className={classes.addContactButton} variant="text" color="primary" onClick={addContact()}>
                    <span className="ico-plus"/>
                    Add contact
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary">
                    Update contacts
                  </Button>
                </div>
              </div>
            </div>
          </RailsForm>
          <Copyright/>
        </div>
      </div>
    </WebsaUITheme>
  );
}
